/* global axios */
import ApiClient from './ApiClient';

// Modelos de e-mail (construtor): CRUD + catálogo, galeria, preview no
// servidor, envio de teste, duplicar, kit da marca e IA.
class MarketingEmailTemplatesAPI extends ApiClient {
  constructor() {
    super('marketing_email_templates', { accountScoped: true });
  }

  catalog() {
    return axios.get(`${this.url}/catalog`);
  }

  // { templates, personal, segments, goals } — filtros: segment, goal, q.
  gallery(params = {}) {
    return axios.get(`${this.url}/gallery`, { params });
  }

  galleryPreview(galleryId) {
    return axios.get(`${this.url}/gallery_preview`, {
      params: { gallery_id: galleryId },
    });
  }

  createFromGallery(galleryId) {
    return axios.post(this.url, { gallery_id: galleryId });
  }

  // Só super admin: publica/atualiza este modelo na galeria global.
  publishGallery(id, payload) {
    return axios.post(`${this.url}/${id}/publish_gallery`, payload);
  }

  createFromPreset(preset, attrs = {}) {
    return axios.post(this.url, { preset, marketing_email_template: attrs });
  }

  preview(source, { dark = false } = {}) {
    return axios.post(`${this.url}/preview`, {
      marketing_email_template: source,
      dark,
    });
  }

  sendTest(id, inboxId) {
    return axios.post(`${this.url}/${id}/send_test`, { inbox_id: inboxId });
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  applyBrandKit(id) {
    return axios.post(`${this.url}/${id}/apply_brand_kit`);
  }

  // HTML pronto: FormData com `file` (.html/.zip) ou `html`, e `name`.
  importHtml(formData) {
    return axios.post(`${this.url}/import_html`, formData);
  }

  // Links das redes conectadas da conta: { items: [{ network, url }] }.
  socialLinks() {
    return axios.get(`${this.url}/social_links`);
  }

  // Capa do elemento Vídeo: { asset_id, url } (imagem com ▶ na biblioteca).
  videoThumbnail(url, assetId = null) {
    return axios.post(`${this.url}/video_thumbnail`, {
      url,
      asset_id: assetId,
    });
  }

  aiCompose({ id, brief, mode }) {
    return axios.post(`${this.url}/ai_compose`, { id, brief, mode });
  }

  aiEdit(id, instruction, source) {
    return axios.post(`${this.url}/${id}/ai_edit`, {
      instruction,
      marketing_email_template: source,
    });
  }

  // Chat de IA do editor v2: { reply, layout, layout_changed, changed_ids,
  // warnings, charged, subject?, preheader? }. Não salva o modelo. Sem retry.
  // 95 s: abaixo dos 100 s da Cloudflare e acima dos 90 s do servidor (que
  // termina, e estorna se precisar, antes de a tela desistir).
  aiChat(id, payload) {
    return axios.post(`${this.url}/${id}/ai_chat`, payload, {
      timeout: 95000,
    });
  }

  // HTML importado → editor visual: sem create devolve { layout, preview_html,
  // stats }; com create devolve o modelo novo (o original não muda).
  convertToLayout(id, { create = false } = {}) {
    return axios.post(`${this.url}/${id}/convert_to_layout`, { create });
  }

  aiSubjects(id, source) {
    return axios.post(`${this.url}/${id}/ai_subjects`, {
      marketing_email_template: source,
    });
  }
}

export default new MarketingEmailTemplatesAPI();
